import { Controller } from "stimulus"
import confetti from "canvas-confetti"

// Very high z-index to ensure confetti appears above all elements including modals
const CONFETTI_Z_INDEX = 1000000

export default class extends Controller {
  static values = {
    pattern: String,
    autoFire: Boolean
  }

  connect() {
    // Default to auto-fire if not explicitly set to false
    if (this.hasAutoFireValue ? this.autoFireValue : true) {
      this.fire()
    }
  }

  fire() {
    const pattern = this.hasPatternValue ? this.patternValue : "default"
    switch (pattern) {
      case "achievement":
        this.achievementBurst()
        break
      case "course_complete":
        this.courseCompleteShower()
        break
      case "lesson_complete":
        this.lessonCompleteBurst()
        break
      default:
        this.defaultBurst()
    }
  }

  // Achievement unlock: Purple/gold burst, 3 seconds
  achievementBurst() {
    const duration = 3000
    const end = Date.now() + duration

    const colors = ["#6a4dcb", "#ffd700", "#8b5cf6", "#a855f7"]

    const frame = () => {
      confetti({
        particleCount: 4,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors,
        zIndex: CONFETTI_Z_INDEX
      })
      confetti({
        particleCount: 4,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors,
        zIndex: CONFETTI_Z_INDEX
      })

      if (Date.now() < end) {
        requestAnimationFrame(frame)
      }
    }

    frame()

    // Big initial burst from center
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: colors,
      zIndex: CONFETTI_Z_INDEX
    })
  }

  // Course complete: 5-second continuous shower
  courseCompleteShower() {
    const duration = 5000
    const animationEnd = Date.now() + duration
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: CONFETTI_Z_INDEX }

    const randomInRange = (min, max) => Math.random() * (max - min) + min

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now()

      if (timeLeft <= 0) {
        return clearInterval(interval)
      }

      const particleCount = 50 * (timeLeft / duration)

      // Create confetti from random positions
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        colors: ["#6a4dcb", "#ffd700", "#8b5cf6", "#00a08d", "#22c55e"]
      })
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        colors: ["#6a4dcb", "#ffd700", "#8b5cf6", "#00a08d", "#22c55e"]
      })
    }, 250)
  }

  // Lesson complete: Subtle celebration
  lessonCompleteBurst() {
    confetti({
      particleCount: 60,
      spread: 60,
      origin: { y: 0.7 },
      colors: ["#6a4dcb", "#8b5cf6", "#00a08d"],
      zIndex: CONFETTI_Z_INDEX
    })
  }

  // Default burst
  defaultBurst() {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      zIndex: CONFETTI_Z_INDEX
    })
  }

  // Manual trigger method for external calls
  trigger(event) {
    const pattern = event?.params?.pattern || this.patternValue
    this.patternValue = pattern
    this.fire()
  }
}
